export default () => {
  return {
    uploadQueue: [],
  };
};
